import React from 'react';
import { Sparkles, X, BookOpen, Plus, Loader2 } from 'lucide-react';
import { formatCurrency } from '../../utils/currency';
import { CartItem, Book } from '../../types/book.types';
import { BookRecommendation } from '../../services/BooksService';
import './RecommendationsModal.css';

interface RecommendationsModalProps {
  /** Linea del ticket para la que se sugiere. */
  target: CartItem;
  recommendations: BookRecommendation[];
  isLoading: boolean;
  error: string | null;
  onClose: () => void;
  onAdd: (book: Book) => void;
}

export function RecommendationsModal({
  target,
  recommendations,
  isLoading,
  error,
  onClose,
  onAdd
}: RecommendationsModalProps) {
  return (
    <div className="rec-overlay">
      <div className="rec-container">
        <div className="rec-header">
          <div className="rec-header-left">
            <div className="rec-icon">
              <Sparkles style={{ width: '2rem', height: '2rem' }} />
            </div>
            <div>
              <h3 className="rec-title">Sugerencias de Venta</h3>
              <p className="rec-subtitle">
                Complementos perfectos para: <span className="rec-subtitle-target">{target.title}</span>
              </p>
            </div>
          </div>
          <button onClick={onClose} className="rec-close" aria-label="Cerrar">
            <X style={{ width: '2rem', height: '2rem' }} />
          </button>
        </div>

        <div className="rec-body">
          {isLoading ? (
            <div className="rec-state">
              <Loader2 className="rec-spinner" style={{ width: '3rem', height: '3rem' }} />
              <p className="rec-state-text">Buscando recomendaciones...</p>
            </div>
          ) : error ? (
            <div className="rec-state">
              <p className="rec-state-text">{error}</p>
            </div>
          ) : recommendations.length === 0 ? (
            <div className="rec-state">
              <Sparkles style={{ width: '3rem', height: '3rem', opacity: 0.3 }} />
              <p className="rec-state-text">No hay sugerencias disponibles para este libro.</p>
            </div>
          ) : (
            recommendations.map(({ book, reason }) => (
              <div key={book.id} className="rec-card">
                <div className="rec-cover">
                  <BookOpen style={{ width: '2.5rem', height: '2.5rem' }} />
                </div>
                <div className="rec-info">
                  {book.category && <span className="rec-category">{book.category}</span>}
                  <h4 className="rec-book-title">{book.title}</h4>
                  <p className="rec-book-meta">
                    {book.author}{book.author ? ' • ' : ''}{formatCurrency(book.price)}
                  </p>
                  <div className="rec-reason">"{reason}"</div>
                </div>
                <button onClick={() => onAdd(book)} className="rec-add" aria-label={`Añadir ${book.title}`}>
                  <Plus style={{ width: '2.5rem', height: '2.5rem' }} />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
